import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import ShareableResourcePopover from 'legacy/packages/unit-outline/src/components/_shared/ShareableResourcePopover';
import { getResourceAddress, isS3Resource } from 'legacy/src/utility/utils';
import ResourceTypes from 'legacy/packages/unit-outline/src/constants';
import A11y from 'chameleon/ui-stack/utilities/a11y';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import SingleAction from 'chameleon/ui-stack/ui/assessments/actions/single-action';

const ItemActionShare = (props) => {
  const {
    disabled,
    onClick,
    isPreApSubject,
    item,
    subject,
    className,
    isShared,
    text,
  } = props;

  const popOverProps = {
    displayName: item.displayName,
    external: true,
    url: item.url,
    onClick,
    label: 'Share in Pre-AP Classroom',
  };

  const isURLResource = item.__typename === ResourceTypes.URL;

  if (item && isURLResource && isS3Resource(item.url)) {
    popOverProps.url = getResourceAddress(item.url, subject);
  }

  const ShareButton = ({ disabled, onClick }) => (
    <ButtonWithIcon
      isIcon
      isNaked
      icon={isShared ? 'shared' : 'share'}
      accessibility={{
        'aria-label': isShared ? 'Shared resource' : 'Share resource',
      }}
      iconWidth={20}
      iconHeight={20}
      iconClassName={isShared ? 'text-green-500' : ''}
      tabIndex="0"
      disabled={disabled}
      onClick={onClick}
    />
  );

  return (
    <div
      className={cn({
        [className]: className,
        'align-top': isURLResource,
      })}
    >
      {text ? (
        <SingleAction onClick={onClick} icon={isShared ? 'shared' : 'share'}>
          {text}
        </SingleAction>
      ) : (
        <A11y>
          {!(isPreApSubject && item && item.isGoogleClassroomShareable) ? (
            <ShareButton disabled={disabled} onClick={onClick} />
          ) : (
            <ShareableResourcePopover {...popOverProps} key={`${item.url}`}>
              <ShareButton />
            </ShareableResourcePopover>
          )}
        </A11y>
      )}
    </div>
  );
};

ItemActionShare.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

ItemActionShare.defaultProps = {
  disabled: false,
  onClick: () => {},
};

export default ItemActionShare;
